import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageShell from "../components/PageShell";
import { Contact } from "../components/Contact";

export default function ContactPage() {
  const navigate = useNavigate();
  return (
    <PageShell>
      <section className="px-6 md:px-10 lg:px-16 pt-36 pb-2 md:pt-40">
        <div className="max-w-7xl mx-auto">
          <button onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-silver/60 hover:text-gold transition-colors text-sm font-body" data-testid="contact-back">
            <ArrowLeft size={16} className="rtl-flip" /> Back to home
          </button>
        </div>
      </section>
      <Contact />
    </PageShell>
  );
}
